// modules
import { LStorage } from 'modules/Storage';
import ScripsDb from 'modules/Db';
import Logger from 'modules/Logger';
// workers
import { PARSER_WORKER } from './modules/BOD/workers';
import { BOD_URL } from './modules/BOD/workers/constants';

class BodSearchService {
  bodParsingPromise?: Promise<boolean>;

  private async needBodParse(serverFileTimeStamp: number): Promise<boolean> {
    // check file in storage
    const localTimeStamp = LStorage.getItem('SCRIP_TIMESTAMP');

    const versionsDontMatch = !(serverFileTimeStamp === Number(localTimeStamp));

    const dbWriteStatus = await ScripsDb.getMetadata('dbWriteStatus');
    Logger.log('BOD', 'dbWriteStatus---->', dbWriteStatus);

    // if should fetch new data - clear storage
    if (!localTimeStamp || versionsDontMatch || dbWriteStatus !== 'completed') {
      return true;
    }
    return false;
  }

  private getBODTimestamp = async () => {
    const response = await fetch(
      `${BOD_URL}/bod_timestamp.json?d=${Date.now()}`,
    );

    const { t: bod_timestamp } = (await response.json()) as TimeStampResponse;

    const needBodParse = await this.needBodParse(bod_timestamp);

    const incognito = LStorage.getItem('INCOGNITO_WINDOW') === 'YES';

    return { needBodParse, needInsertinDb: needBodParse && !incognito, bodTimestamp: bod_timestamp };
  };

  searchExchangeToken = async (exchangeToken: string) => {
    await this.bodParsingPromise;

    return PARSER_WORKER.postMessage<DataSchema | null, SearchByTokenMessage>({
      event: 'SEARCH_BY_TOKEN',
      data: exchangeToken,
    });
  };

  searchByInstrumentKey = async (instrumentKey: string) => {
    await this.bodParsingPromise;

    return PARSER_WORKER.postMessage<
      DataSchema | null,
      SearchByInstrumentKeyMessage
    >({
      event: 'SEARCH_BY_INSTRUMENT_KEY',
      data: instrumentKey,
    });
  };

  getOptionExpiries = (exchangeToken: string, spotToken: string) =>
    PARSER_WORKER.postMessage<OptionExpirySchema[], GetOptionExpiryMessage>({
      event: 'GET_OPTION_EXPIRY',
      data: { exchangeToken, spotToken },
    });

  getOptionStrikesForExpiry = (exchangeToken: string, expiry: number) =>
    PARSER_WORKER.postMessage<StrikeSchema[], GetOptionStrikesForExpiryMessage>(
      {
        event: 'GET_OPTION_STRIKES_FOR_EXPIRY',
        data: { exchangeToken, expiry },
      },
    );

  getFutureScripForExpiry = (exchangeToken: string) =>
    PARSER_WORKER.postMessage<DataSchema, GetFutureScripForExpiryMessage>({
      event: 'GET_FUTURE_SCRIP_FOR_EXPIRY',
      data: { exchangeToken },
    });

  bodParse = () => {
    this.bodParsingPromise = new Promise(res => {
      (async () => {
        const { needInsertinDb, needBodParse, bodTimestamp } = await this.getBODTimestamp();

        Logger.log('BOD', 'needInsertinDb--->', { needInsertinDb, needBodParse });

        if (needBodParse) {
          await PARSER_WORKER.postMessage({
            event: 'BOD_PARSE',
          });
        }

        res(true);

        if (needInsertinDb) {
          await PARSER_WORKER.postMessage({
            event: 'INSERT_DATA_IN_DB',
          });
          // after inserting data in db, set the timestamp
          LStorage.setItem('SCRIP_TIMESTAMP', bodTimestamp.toString());
        }
      })();
    });
  };
}

export default new BodSearchService();
